import React from 'react'

const META = {
  new:         { label: 'ใหม่',          bg: 'bg-danger',  icon: 'ri-error-warning-line' },
  received:    { label: 'รับเรื่อง',     bg: 'bg-warning text-dark', icon: 'ri-inbox-line' },
  in_progress: { label: 'กำลังดำเนินการ', bg: 'bg-info text-dark',    icon: 'ri-tools-line' },
  done:        { label: 'เสร็จสิ้น',     bg: 'bg-success', icon: 'ri-checkbox-circle-line' },
  cancelled:   { label: 'ยกเลิก',        bg: 'bg-secondary', icon: 'ri-close-circle-line' },
}

export default function StatusBadge({ status, className = '' }) {
  const m = META[status] || { label: status, bg: 'bg-light text-dark', icon: 'ri-question-line' }
  return (
    <span className={`badge ${m.bg} ${className}`}>
      <i className={`${m.icon} me-1`} />
      {m.label}
    </span>
  )
}

export const STATUS_LIST = Object.keys(META).map(k => ({ value: k, ...META[k] }))
